import { h } from "preact";
import { withWidgetConfiguration, } from "../config/withWidgetConfiguration";
import WithCss from "./WithCss";
var WithGlobalCss = function (props) {
    var styles = props.styles;
    var _a = props.widgetConfiguration, sharedCssUrls = _a.sharedCssUrls, useShadowDOM = _a.useShadowDOM;
    if (useShadowDOM) {
        var cssUrls = [];
        if (sharedCssUrls !== undefined) {
            cssUrls = sharedCssUrls;
        }
        styles = cssUrls
            .map(function (url) { return "@import url(" + url + ");"; })
            .concat([props.styles ? props.styles.toString() : ""])
            .join("\n");
    }
    return h(WithCss, { styles: styles }, props.children);
};
WithGlobalCss.displayName = "WithGlobalCss";
/**
 * Injects custom style and the global style. This should be used only once
 * in your widget (usually at the toplevel).
 *
 * If you want to inject other styles at a lower level, use `<WithCss>`.
 */
export default withWidgetConfiguration(WithGlobalCss);
//# sourceMappingURL=WithGlobalCss.js.map